import { capturePostHogEvent } from "@/utils/posthog";

import useBasicData from "./useBasicData";

export const useTrackNextAppSwitch = () => {
  const { user } = useBasicData();

  return (
    source:
      | "banner"
      | "workspace_menu"
      | "sidebar"
      | "unsupported_workflow_node",
  ) => {
    if (user?.id) {
      capturePostHogEvent("next_app.switched", user.id, { source });
    }
  };
};
